import { Router } from "vue-router";
import useSessionHanlder from "@/lib/useSessionHandler";
import useSessionValidate from "@/lib/useSessionValidate";
import store from "@/store";
import { useCenter } from "@/lib/_API/useCenter";
import dayjs from "@/utils/dayjs";

export default function routerBeforeAction(router: Router) {
  const { useSignout } = useSessionHanlder();
  const { useRouterSessionValidate } = useSessionValidate();

  router.beforeEach(async (to, from, next) => {
    const isTruthy = await useRouterSessionValidate();

    if (to.meta.requireAuth) {
      // 인증 필요한 페이지인 경우
      if (isTruthy) {
        next();

        //접수페이지 이동시
        if (to.fullPath.startsWith("/outbound")) {
          const outboundType = to.fullPath.slice(
            to.fullPath.lastIndexOf("/") + 1
          );

          const { getCenterNotice } = useCenter();

          //로컬스토리지에 오늘 접수공지팝업 표시 데이터없는 경우 저장
          const getPopupLocalStorage = localStorage.getItem("popupOpenFrom");
          if (getPopupLocalStorage)
            localStorage.setItem("popupOpenFrom", getPopupLocalStorage);
          else store.dispatch("localStorage/savePopupDataLocalStorage");

          //오늘 팝업 그만보기 확인
          const isOpenToday = (outboundType: string) => {
            const localIsShowToday = localStorage.getItem("popupOpenFrom");
            if (!localIsShowToday) return true;

            const { quick, parcel, registry, global } =
              JSON.parse(localIsShowToday);

            if (outboundType === "quick")
              return dayjs().isSameOrAfter(quick, "day");
            if (outboundType === "parcel" || outboundType === "mass-parcel")
              return dayjs().isSameOrAfter(parcel, "day");
            if (outboundType === "registry")
              return dayjs().isSameOrAfter(registry, "day");
            if (outboundType === "global")
              return dayjs().isSameOrAfter(global, "day");
            else return true;
          };

          //url + isOpenToday 데이터계산
          const computedPopupOpen = (url: string, isTodayShow: boolean) => {
            if (url && isTodayShow) return true;
            else return false;
          };

          getCenterNotice().then((response) => {
            store.dispatch("notice/updateNotice", response.centerResponse);

            switch (outboundType) {
              case "parcel":
              case "mass-parcel":
                store.dispatch(
                  "notice/updateIsNoticeOpen",
                  computedPopupOpen(
                    store.getters["notice/getNoticeInfo"].parcelImageUrl,
                    isOpenToday(outboundType)
                  )
                );
                return;

              case "quick":
                store.dispatch(
                  "notice/updateIsNoticeOpen",
                  computedPopupOpen(
                    store.getters["notice/getNoticeInfo"].quickImageUrl,
                    isOpenToday(outboundType)
                  )
                );
                return;
              case "registry":
                store.dispatch(
                  "notice/updateIsNoticeOpen",
                  computedPopupOpen(
                    store.getters["notice/getNoticeInfo"].mailImageUrl,
                    isOpenToday(outboundType)
                  )
                );
                return;
              case "global":
                store.dispatch(
                  "notice/updateIsNoticeOpen",
                  computedPopupOpen(
                    store.getters["notice/getNoticeInfo"].globalImageUrl,
                    isOpenToday(outboundType)
                  )
                );
                return;
              default:
                store.dispatch("notice/updateIsNoticeOpen", false);
                return;
            }
          });
        }
      } else {
        useSignout();
        next({
          path: "/signin",
        });
        //세션스토리지에 저장
        sessionStorage.setItem("redirectURL", to.fullPath);
      }
    } else {
      // 인증 필요 없는 페이지 인 경우
      if (!isTruthy) useSignout();
      next();
    }
  });
}
